import { render, staticRenderFns } from "./anularIncapacidad.vue?vue&type=template&id=24002f03&"
import script from "./anularIncapacidad.vue?vue&type=script&lang=js&"
export * from "./anularIncapacidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports